﻿import { projectSettings } from "../../config";

import PersonalDetails from "./PersonalDetails.svelte";
import SurgeryDetails from "./SurgeryDetails.svelte";
import TreatmentDetails from "./TreatmentDetails.svelte";
import Confirmation from "./Confirmation.svelte";
import Review from "./Review.svelte";
import ThankYou from "./ThankYou.svelte";
import Error from "../Error.svelte";
import Verify from "./Verify.svelte";


const title = projectSettings.classActionName;

const questionnairePageList = [
    {
        pageIndex: 0,
        component: Verify,
        title: "Claimant Registration Form",
        showInTracker: false,
        routeId: "/Verify",
        nextPage: "/Questionnaire/PersonalDetails",
        properties: {
            pageTitle: `${title} - Verify`,
        },
    },
    {
        pageIndex: 1,
        component: PersonalDetails,
        title: "Personal Details",
        showInTracker: true,
        routeId: "/Questionnaire/PersonalDetails",
        nextPage: (model) => model.confirmationPage ? "/Questionnaire/Confirmation" : "/Questionnaire/SurgeryDetails",
        previousPage: "/Verify",
        properties: {
            pageTitle: `${title} - Personal Details`,
            persistUrl: "/api/project",
            lastVisitedPage: "Personal Details",
        },
    },
    {
        pageIndex: 2,
        component: SurgeryDetails,
        title: "Surgery Details",
        showInTracker: true,
        routeId: "/Questionnaire/SurgeryDetails",
        nextPage: "/Questionnaire/TreatmentDetails",
        previousPage: "/Questionnaire/PersonalDetails",
        properties: {
            pageTitle: `${title} - Surgery Details`,
            persistUrl: "/api/project",
            lastVisitedPage: "Surgery Details",
        },
    },
    {
        pageIndex: 3,
        component: TreatmentDetails,
        title: "Treatment Details",
        showInTracker: true,
        routeId: "/Questionnaire/TreatmentDetails",
        nextPage: "/Questionnaire/Confirmation",
        previousPage: "/Questionnaire/SurgeryDetails",
        properties: {
            pageTitle: `${title} - Treatment Details`,
            persistUrl: "/api/project",
            lastVisitedPage: "Treatment Details",
        },
    },
    {
        pageIndex: 4,
        component: Confirmation,
        title: "Confirmation",
        showInTracker: true,
        routeId: "/Questionnaire/Confirmation",
        previousPage: "/Questionnaire/TreatmentDetails",
        nextPage: "/Questionnaire/ThankYou",
        properties: {
            pageTitle: `${title} - Confirmation`,
            nextPageLabel: "Submit",
            persistUrl: `/api/questionnaire?timezoneOffset=${(-1 * (new Date().getTimezoneOffset()))}`,
            lastVisitedPage: "Confirmation",
        },
    },
    {
        pageIndex: 5,
        component: ThankYou,
        title: "Registration Submitted",
        showInTracker: false,
        routeId: "/Questionnaire/ThankYou",
        properties: {
            pageTitle: `${title} - Thank you`,
        },
    },
    {
        pageIndex: 6,
        component: Review,
        title: "Review",
        showInTracker: false,
        routeId: "/Review",
        properties: {
            pageTitle: `${title} - Review`,
        },
    },
    {
        pageIndex: 9,
        component: Error,
        title: "Error",
        showInTracker: false,
        routeId: "*/Error",
        properties: {
            pageTitle: `${title} - Error`,
        },
    },
];

export default questionnairePageList
